import { connect } from 'react-redux';

import { selectActiveVenueId } from 'selectors/general';

import { selectServices } from '../../Services/Services.selectors';
import { goToTab as goToTabAction } from '../../ManageServices.saga';
import { createResource as createResourceAction } from '../Resources.saga';
import { messages } from '../Resources.messages';
import ResourceForm from './ResourceForm';

export const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);

  return {
    venueId,
    defaultValues: {},
    isLoaded: true,
    servicesList: selectServices(state),
    title: messages.form.addResource,
  };
};

const mapDispatchToProps = {
  createResource: createResourceAction,
  goToTab: goToTabAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { createResource, goToTab } = dispatchProps;
  return {
    ...stateProps,
    handleCancel: () => goToTab(),
    handleSubmit: createResource,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ResourceForm);
